import { useIntl } from 'react-intl-next';

import type {
	ExtensionConfiguration,
	ToolbarExtensionConfiguration,
} from '@atlaskit/editor-plugin-selection-extension';
import AddIcon from '@atlaskit/icon/core/add';
import NoteIcon from '@atlaskit/icon/core/note';

import { sharedI18n } from '../sharedI18n';

import { useCreateNoteFromSelection } from './useCreateNoteFromSelection';

export const useNoteSelectionExtension = () => {
	const { formatMessage } = useIntl();
	const { handleCreateNoteClick } = useCreateNoteFromSelection({
		source: 'useNoteSelectionExtension',
	});

	const toolbarConfiguration: ToolbarExtensionConfiguration = {
		getToolbarItem: () => ({
			icon: NoteIcon,
			tooltip: formatMessage(sharedI18n.addToNote),
		}),
		getMenuItems: () => {
			return [
				// MODES-7072: Show recent notes
				// {
				// 	label: 'Lorem ipsum',
				// 	icon: NoteIcon,
				// 	onClick: () => alert('Lorem ipsum clicked'),
				// },
				{
					label: formatMessage(sharedI18n.createNote),
					icon: AddIcon,
					onClick: handleCreateNoteClick,
				},
			];
		},
	};

	const noteSelectionExtension: ExtensionConfiguration = {
		key: 'note-contextual-create',
		source: 'first-party',
		inlineToolbar: toolbarConfiguration,
	};

	return {
		extensionList: [noteSelectionExtension],
	};
};
